var exports = {
  "Q": "xe7b6e3d6--8cc5d3--text",
};

module.exports = exports;
